module.exports = __webpack_public_path__ + "img/staticsSumAct.eec7d550.png";